function isRecentObject(object) {
  return object?.catalogGroups?.includes("recent") === true;
}

export function isTrackerObject(object, requestedId = null) {
  if (requestedId !== null && requestedId !== "" && String(object?.id) === String(requestedId)) return true;
  return isRecentObject(object) || Number(object?.noradId) === 25544;
}

export function trackerObjectLabel(object) {
  if (!isRecentObject(object)) return object?.name || "Tuntematon kohde";
  if (object.launchName) return object.launchName;
  if (object.launchKey) return `Laukaisu ${object.launchKey}`;
  return object?.name || "Tuntematon kohde";
}
